import { APIModel } from "./api-model";

export class OrganGroup extends APIModel {
  id!: string;
  name!: string;
  name_to_display!: string;
  organ_code!: string;

  static fieldsToMap = {
    direct: [
      'id',
      'name',
      'name_to_display',
      'organ_code'
    ]
  }

  static buildFromAPI(record: any): OrganGroup {
    const row = new OrganGroup();
    record = record || {};

    this.mapFieldsDirectly<OrganGroup>(OrganGroup.fieldsToMap.direct, record, row);

    return row
  }
}